<template>
    <section>
        <section v-if="currentType === 'sms'">
            <SMSMessageItem 
                v-for="msg in messagesArray"
                :key="msg.name"
                :message="msg"
                :prettyFields="prettyFields"
            />
        </section>
        <section v-else-if="currentType === 'push'">
            <PushMessageItem 
                v-for="msg in messagesArray"
                :key="msg.name"
                :message="msg"
                :prettyFields="prettyFields"
            />
        </section>
    </section>
</template>

<script>
import SMSMessageItem from "@/components/settings/messages_emails/SMSMessageItem.vue";
import PushMessageItem from "@/components/settings/messages_emails/PushMessageItem.vue";

export default {
    name: "message_list",
    components: {
        SMSMessageItem,
        PushMessageItem
    },
    props: {
        messages: Object,
        prettyFields: Object,
        currentType: null
    },
    data: function() {
        return {
            messagesArray: []
        }
    },
    mounted: function() {
        //Combines the messages and fields array to produce one array with name, message, enabled and allowed fields for each message type
        for(const msg of Object.keys(this.messages)) {
            this.messagesArray.push({
                name: msg,
                ...this.messages[msg],
            })
        }

        this.messagesArray.sort(function(a, b) {
            return a.position - b.position;
        });
    }
};
</script>